// extracted by mini-css-extract-plugin
export var aboveInput = "_jv-0";
export var actionButton = "_jv-5";
export var actionButtonContainer = "_jv-1";
export var actionIcon = "_jv-6";
export var aiInfoContainer = "_jv-2";
export var attachmentWrapper = "_jv-7";
export var bold = "_jv-3";
export var checkIcon = "_jv-8";
export var clickingRecipientBar = "_jv-11";
export var commentThreadSwitch = "_jv-a";
export var draftImage = "_jv-b";
export var draftImageContainer = "_jv-c";
export var draftImages = "_jv-e";
export var editButton = "_jv-g";
export var editor = "_jv-f";
export var editorContainer = "_jv-y";
export var editorErrorTooltipWrapper = "_jv-9";
export var headerDivider = "_jv-h";
export var icon = "_jv-i";
export var info = "_jv-j";
export var internal = "_jv-n";
export var internalDivider = "_jv-k";
export var internalMessage = "_jv-l";
export var messageInputCard = "_jv-m";
export var messageInputForm = "_jv-o";
export var messageInputFormInternal = "_jv-p";
export var options = "_jv-q";
export var publicMessageCustomer = "_jv-s";
export var publicMessageMerchant = "_jv-r";
export var removeImageButton = "_jv-d";
export var replyButtons = "_jv-t";
export var showSignatureButton = "_jv-u";
export var spinner = "_jv-v";
export var verticalButtonDivider = "_jv-4";
export var visibilitySelector = "_jv-w";
export var warning = "_jv-x";
export var wrappingText = "_jv-z";
export var writingInternalNoteTopBorder = "_jv-10";